<template>
  <div class="pay-result-wrap">
    <div class="pay-result-box">
      <div class="result-icon">❌</div>
      <h2>결제가 취소되었습니다</h2>
      <p class="error-msg">{{ errorMsg }}</p>
      <p class="error-code" v-if="errorCode">에러코드: {{ errorCode }}</p>
      <div class="btn-wrap">
        <button @click="goBack" class="btn-back">← 다시 시도</button>
        <button @click="goToMain" class="btn-main">메인으로</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtxFail_pg',

  data() {
    return {
      errorMsg:  '결제가 취소되었거나 실패했습니다.',
      errorCode: '',
    };
  },

  created() {
    // 토스 failUrl 리다이렉트 파라미터
    const { message, code } = this.$route.query;
    if (message) this.errorMsg  = message;
    if (code)    this.errorCode = code;

    // sessionStorage 정리
    sessionStorage.removeItem('hotelBookingData');
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goToMain() {
      this.$router.push({ path: '/' });
    }
  }
};
</script>

<style scoped>
.pay-result-wrap {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 16px;
  font-family: 'Noto Sans KR', sans-serif;
}

.pay-result-box {
  width: 100%;
  max-width: 480px;
  background: #fff;
  border-radius: 16px;
  padding: 40px 32px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.1);
  text-align: center;
}

.result-icon { font-size: 56px; margin-bottom: 16px; }

h2 {
  font-size: 20px; font-weight: 800;
  color: #c53030; margin-bottom: 16px;
}

.error-msg {
  font-size: 14px; color: #666;
  margin-bottom: 8px; line-height: 1.6;
}

.error-code {
  font-size: 12px; color: #aaa;
  margin-bottom: 24px;
}

.btn-wrap {
  display: flex; gap: 10px; margin-top: 24px;
}

.btn-back {
  flex: 1; padding: 13px;
  background: #f0f0f0; color: #555;
  border: none; border-radius: 8px;
  font-size: 14px; font-weight: 600;
  cursor: pointer; transition: background 0.15s;
}
.btn-back:hover { background: #e2e8f0; }

.btn-main {
  flex: 1; padding: 13px;
  background: #1a6eb5; color: #fff;
  border: none; border-radius: 8px;
  font-size: 14px; font-weight: 700;
  cursor: pointer; transition: background 0.2s;
}
.btn-main:hover { background: #86cd53; }
</style>